import React, { useState } from 'react'
import Img from '../images/sanlogo.PNG'
import {Link} from 'react-router-dom'
import {GiHamburgerMenu} from 'react-icons/gi'
import {AiOutlineClose} from 'react-icons/ai'

const Navbar = () => {
  const[open, setOpen] = useState(false);
  return (
    <nav className=  {`overflow-hidden container ${open ? 'sm:mb-72' : 'mb-8'} md:mx-auto p-6 bg-bgNavbar h-1/2 md:mb-0`}>
        <div className="flex flex-col space-y-20 md:space-y-8  lg:flex-row items-center justify-between lg:space-y-0 ">
            <div className="pt-2  min-w-max min-h-max">
     <Link to = '/'>  <img src={Img} alt="lauda ka pic" className="absolute left-3 w-fit md:w-full md:h-full rounded-lg md:-ml-6 md:static"  /></Link>

            </div>
            <div onClick={()=>setOpen(!open)} className='text-3xl absolute right-4 -top-10 sm:-top-12 sm:right-8 cursor-pointer block md:hidden'>
            {open ? <AiOutlineClose/> : <GiHamburgerMenu/>}
            </div>
          {/* Menu items */}
          <div  className={`flex flex-col sm:absolute sm:left-0 sm:pl-12 space-y-4
            md:static md:space-x-12 lg:space-x-14 xl:space-x-24 md:block transition-all duration-500 ease-in
            ${open ?'top-10 opacity-100' : '-top-80 hidden ease-in '} md:opacity-100 `}>
          <Link to="/" 
          className="font-cursive font-extrabold text-2xl hover:text-blue-600 ">Home</Link>
          <Link to="/project"
           className="font-cursive font-extrabold text-2xl hover:text-blue-600">Project</Link>
          <Link to="/technology" 
          className="font-cursive font-extrabold text-2xl hover:text-blue-600">Techs</Link>
          <Link to="/about" 
          className="font-cursive font-extrabold text-2xl hover:text-blue-600">About</Link>
          <Link to="/contact" 
          className="font-cursive font-extrabold text-2xl hover:text-blue-600">Contact</Link>
          </div>
        </div>
    </nav>
  )
}

export default Navbar;